<template>
  <div class="w-32">
    <div
      class="flex flex-row items-center rounded bg-overlay2 py-2 px-3 border-gray-400 border"
      title="Toggle happiness display"
    >
      <img
        :src="`${require('@/assets/images/happiness3.png')}`"
        alt=""
        class="w-8 h-8"
      >
      <span
        class="bg-white w-12 h-4 rounded-full relative ml-2 cursor-pointer flex flex-row items-center"
        @click="toggleDisplayMode"
      >
        <span
          :class="{
            'left-0 bg-rose-500': displayMode === 'normal',
            'left-7 bg-emerald-500': displayMode !== 'normal'
          }"
          class="w-5 h-5 rounded-full absolute trans"
        />
      </span>
    </div>
    <div
      :class="{
        'opacity-50 cursor-default': displayMode === 'normal',
        'opacity-100': displayMode !== 'normal'
      }"
      class="mt-4 flex flex-row items-center cursor-pointer select-none trans ml-1"
      @click="toggleBonusHappiness"
    >
      <span class="w-4 h-4 bg-white rounded text-xs flex flex-row items-center leading-none justify-center">
        <i
          v-if="bonusHappiness"
          class="fas fa-check"
        />
      </span>
      <span class="ml-2 text-white text-xs">
        Show happiness
      </span>
    </div>
  </div>
</template>

<script>
import {useApplicationStore} from '@/roc/stores/ApplicationStore';
import {computed} from 'vue';

export default {
  setup () {
    const appStore = useApplicationStore();

    return {
      displayMode: computed(() => {
        return appStore.displayMode;
      }),
      bonusHappiness: computed(() => {
        return appStore.showBonusHappiness;
      }),
      toggleDisplayMode() {
        appStore.toggleDisplayMode();
      },
      toggleBonusHappiness() {
        appStore.toggleBonusHappiness();
      }
    };
  }
};
</script>

<style>
.trans {
  transition: all 200ms ease-in-out;
}
</style>
